/* Carnis – handlekurv for Carnis-pakken (okt. 2026).
   Lastes i hele butikken av snippets/carnis-pakke-kurv-global.liquid (rendres fra header-gruppen),
   som også lager #carnis-pakke-kurv-config.
   - Storfetalg + Organmix (engangskjøp) i kurven gjøres om til Carnis-pakken (pakkepris).
   - Ligger bare én av dem i kurven, foreslås «legg til den andre» – da blir det pakken (teksten starter med et spørsmål
     og sier ikke noe om frakt).
   - v6 (okt. 2026): kurven foreslår ikke lenger å gjøre pakken om til abonnement (abonnementet er 3 pakker per levering).
   - Én fri frakt-linje øverst i kurven: teller handlebeløpet mot 800 kr («Fri frakt over 800 kroner og alltid
     på abonnement»). Pakken har alltid fri frakt.
   - Lenke til pakken under kjøpsknappen på Storfetalg og Organmix (#cpk-cross-tpl).
   Abonnementsvarer, rabattkoder og varer med automatisk rabatt (f.eks. mengderabatt) slås aldri sammen.
   Nov. 2026 (3-pakk): bare linjer med variant-ID-ene til Storfetalg, Organmix og pakken telles, så 3-pakk-linjer
   (carnis-3-pakk) røres aldri. Mens assets/carnis-kurv-3pakk.js bytter til 3-pakk (window.__carnis3pkBusy), venter
   sammenslåingen til byttet er ferdig, og 3-pakk-skriptet venter på dette skriptet (window.CarnisPakkeKurv.busy()),
   så de to aldri endrer kurven samtidig.
   Bruker temaets cart-drawer.js (renderContents) og pubsub.js (PUB_SUB_EVENTS.cartUpdate). */
(function () {
  'use strict';
  if (window.__cpkKurv) return;
  window.__cpkKurv = true;

  function fmt(cents) {
    var v = Math.round(Number(cents) || 0);
    var kr = Math.floor(v / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var ore = ('0' + (v % 100)).slice(-2);
    return kr + ',' + ore + ' kr';
  }
  function fmtShort(cents) {
    var v = Math.round(Number(cents) || 0);
    if (v % 100 === 0) return Math.floor(v / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
    return fmt(v);
  }
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function tpl(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] !== undefined ? map[k] : m; });
  }
  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* ---------------- Lenke til pakken på Storfetalg og Organmix ---------------- */
  function initCross() {
    var tplEl = document.getElementById('cpk-cross-tpl');
    if (!tplEl || !tplEl.content || document.querySelector('.cpk-cross')) return;
    var target = document.querySelector('.cpdp-buy product-form');
    if (!target || !target.parentNode) return;
    target.parentNode.insertBefore(tplEl.content.cloneNode(true), target.nextSibling);
  }

  /* ---------------- Handlekurv ---------------- */
  function initCart() {
    var cfg = readJSON(document.getElementById('carnis-pakke-kurv-config'));
    if (!cfg || !cfg.bundleAvailable || !cfg.components || cfg.components.length < 2) return;
    var T = cfg.text || {};
    var routes = window.routes || {};
    var cartUrl = (routes.cart_url || '/cart') + '.js';
    var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
    var updateUrl = (routes.cart_update_url || '/cart/update') + '.js';
    var changeUrl = (routes.cart_change_url || '/cart/change') + '.js';
    var freeMin = cfg.freeMin === undefined ? 80000 : Number(cfg.freeMin);
    var busy = false, queued = false, queuedMerge = false, pendingMerge = false, timer = null, message = null;
    window.CarnisPakkeKurv = { busy: function () { return busy; } };
    var truck = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7"/><circle cx="7" cy="17" r="1.8"/><circle cx="17.5" cy="17" r="1.8"/></svg>';

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'cart'); return j; });
      });
    }
    function getCart() {
      return fetch(cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }
    function usesCode(cart) {
      var cartCode = (cart.cart_level_discount_applications || []).some(function (d) { return d.type === 'discount_code'; });
      var lineCode = (cart.items || []).some(function (it) {
        return (it.line_level_discount_allocations || []).some(function (a) { return a.discount_application && a.discount_application.type === 'discount_code'; });
      });
      return cartCode || lineCode;
    }
    function discounted(it) {
      return (it.line_level_discount_allocations || []).some(function (d) { return Number(d.amount) > 0; });
    }
    function analyze(cart) {
      var comps = cfg.components.map(function (c) { return { c: c, lines: [], qty: 0 }; });
      var bundleQty = 0, bundleLines = [], disc = false, onceJars = 0, hasSub = false;
      (cart.items || []).forEach(function (it) {
        if (it.selling_plan_allocation) hasSub = true;
        if (it.variant_id === cfg.bundleVariantId) { bundleQty += it.quantity; bundleLines.push(it); if (!it.selling_plan_allocation) onceJars += 2 * it.quantity; return; }
        if (it.selling_plan_allocation) return;
        cfg.components.forEach(function (c) { if (c.variantId === it.variant_id) onceJars += it.quantity; });
        comps.forEach(function (cs) {
          if (cs.c.variantId === it.variant_id) {
            cs.lines.push(it);
            cs.qty += it.quantity;
            if (discounted(it)) disc = true;
          }
        });
      });
      var pairs = Math.min.apply(null, comps.map(function (cs) { return Math.floor(cs.qty / Math.max(1, cs.c.qty)); }));
      var compSum = cfg.components.reduce(function (s, c) { return s + c.price * c.qty; }, 0);
      // Fri frakt: pakken i kurven, abonnement i kurven, eller handlebeløp over 800 kr
      var total = Number(cart.total_price) || 0;
      var free = (bundleQty > 0 && cfg.alwaysFree) || hasSub || total >= freeMin;
      return { cart: cart, comps: comps, pairs: pairs, bundleQty: bundleQty, bundleLines: bundleLines, compSum: compSum, free: free, total: total, onceJars: onceJars, hasSub: hasSub, code: usesCode(cart), disc: disc };
    }
    // Nov. 2026 (3-pakk): billigste kombinasjon av løse krukker, Carnis-pakker og 3-pakker for det kunden har i kurven.
    // Teller engangslinjer av Storfetalg (t), Organmix (o), Carnis-pakken (1t+1o) og 3-pakkene (etter SKU-innholdet).
    // Prøver alle kombinasjoner (få varer, raskt) og velger den billigste. Løse Storfetalg fra 3 stk får mengderabatten
    // (cfg.talgTier, samme som den automatiske rabatten i Shopify). Endrer kurven bare når den blir billigere enn nå.
    // Aldri ved rabattkode, abonnement, egne linjeegenskaper eller når en vare er utsolgt.
    function codeLine(it) {
      return (it.line_level_discount_allocations || []).some(function (x) { return x.discount_application && x.discount_application.type === 'discount_code'; });
    }
    function optimize(a) {
      var all = cfg.pk3 || [];
      if (!all.length || a.comps.length < 2 || a.code) return null;
      var tV = a.comps[0].c.variantId, oV = a.comps[1].c.variantId, cpV = cfg.bundleVariantId;
      var tP = a.comps[0].c.price, oP = a.comps[1].c.price, cpP = cfg.bundleAvailable === false ? 0 : cfg.bundlePrice;
      var pkById = {}, P = {};
      all.forEach(function (v) { pkById[Number(v.id)] = v; if (v.available) P[Number(v.t) + '-' + Number(v.o)] = v; });
      var T = 0, O = 0, cur = 0, blocked = false, have = {}, lines = {};
      (a.cart.items || []).forEach(function (it) {
        if (it.selling_plan_allocation) return;
        var vid = Number(it.variant_id), t = 0, o = 0;
        if (vid === tV) t = 1; else if (vid === oV) o = 1; else if (vid === cpV) { t = 1; o = 1; }
        else if (pkById[vid]) { t = Number(pkById[vid].t); o = Number(pkById[vid].o); }
        else return;
        if (codeLine(it)) blocked = true;
        var props = it.properties || {};
        if (Object.keys(props).some(function (k) { return k && k.charAt(0) !== '_' && props[k] !== '' && props[k] != null; })) blocked = true;
        T += t * it.quantity; O += o * it.quantity; cur += Number(it.final_line_price) || 0;
        have[vid] = (have[vid] || 0) + it.quantity;
        (lines[vid] = lines[vid] || []).push(it);
      });
      if (blocked || T + O < 2 || T + O > 24) return null;
      var tier = cfg.talgTier || null;
      function singles(rt, ro) { return rt * ((tier && rt >= tier.min && tier.each > 0) ? tier.each : tP) + ro * oP; }
      var p30 = P['3-0'], p21 = P['2-1'], p12 = P['1-2'], p03 = P['0-3'];
      var best = null;
      for (var i = 0; i <= (p30 ? Math.floor(T / 3) : 0); i++)
      for (var j = 0; j <= (p21 ? Math.min(Math.floor(T / 2), O) : 0); j++)
      for (var k = 0; k <= (p12 ? Math.min(T, Math.floor(O / 2)) : 0); k++)
      for (var l = 0; l <= (p03 ? Math.floor(O / 3) : 0); l++)
      for (var m = 0; m <= (cpP ? Math.min(T, O) : 0); m++) {
        var rt = T - 3 * i - 2 * j - k - m, ro = O - j - 2 * k - 3 * l - m;
        if (rt < 0 || ro < 0) continue;
        var cost = i * (p30 ? p30.price : 0) + j * (p21 ? p21.price : 0) + k * (p12 ? p12.price : 0) + l * (p03 ? p03.price : 0) + m * cpP + singles(rt, ro);
        var packs = i + j + k + l + m;
        if (!best || cost < best.cost || (cost === best.cost && packs > best.packs)) best = { cost: cost, packs: packs, want: [[tV, rt], [oV, ro], [cpV, m], [p30 && p30.id, i], [p21 && p21.id, j], [p12 && p12.id, k], [p03 && p03.id, l]] };
      }
      if (!best || best.cost >= cur) return null;
      var adds = [], updates = {}, changed = false, names = [];
      best.want.forEach(function (w) {
        var vid = Number(w[0]), q = w[1];
        if (!vid) return;
        var h = have[vid] || 0;
        if (q > h) { adds.push({ id: vid, quantity: q - h }); changed = true; }
        if (q < h) {
          var need = h - q;
          (lines[vid] || []).slice().reverse().forEach(function (it) {
            if (need <= 0) return;
            var take = Math.min(it.quantity, need);
            updates[it.key] = it.quantity - take;
            need -= take;
          });
          changed = true;
        }
        if (q > 0) {
          var nm;
          if (vid === tV) nm = q + ' løs' + (q > 1 ? 'e' : '') + ' Storfetalg' + (tier && q >= tier.min ? ' (' + fmtShort(tier.each) + ' per krukke fra ' + tier.min + ' stk)' : '');
          else if (vid === oV) nm = q + ' løs' + (q > 1 ? 'e' : '') + ' Organmix';
          else if (vid === cpV) nm = (q > 1 ? q + ' × ' : '') + (cfg.bundleTitle || 'Carnis-pakken');
          else nm = (q > 1 ? q + ' × ' : '') + '3-pakk (' + (pkById[vid].title || '') + ')';
          names.push(nm);
        }
      });
      if (!changed) return null;
      var nmTxt = names.length > 1 ? names.slice(0, -1).join(', ') + ' og ' + names[names.length - 1] : (names[0] || '');
      return { adds: adds, updates: updates, save: T * tP + O * oP - best.cost, names: nmTxt };
    }
    function applyPlan(plan) {
      var step = plan.adds.length ? post(addUrl, { items: plan.adds }) : Promise.resolve(null);
      return step.then(function (added) {
        if (!Object.keys(plan.updates).length) return;
        return post(updateUrl, { updates: plan.updates }).catch(function (err) {
          // Rull tilbake det som ble lagt til
          var back = {};
          ((added && added.items) || []).forEach(function (li) { back[li.key] = Math.max(0, li.quantity - (plan.adds.filter(function (x) { return x.id === li.variant_id; })[0] || { quantity: 0 }).quantity); });
          return (Object.keys(back).length ? post(updateUrl, { updates: back }) : Promise.resolve()).then(function () { throw err; });
        });
      });
    }
    function reduceLines(cs, units, updates) {
      var need = units;
      for (var i = cs.lines.length - 1; i >= 0 && need > 0; i--) {
        var it = cs.lines[i];
        var take = Math.min(it.quantity, need);
        updates[it.key] = (updates[it.key] !== undefined ? updates[it.key] : it.quantity) - take;
        need -= take;
      }
    }
    // Bytter ut komponentene med pakken: legg til pakken først, reduser så komponentene (ruller tilbake ved feil)
    function swap(a, packs, take, toVariant) {
      var updates = {};
      a.comps.forEach(function (cs) {
        var units = take ? (take[cs.c.variantId] || 0) : cs.c.qty * packs;
        if (units > 0) reduceLines(cs, units, updates);
      });
      return post(addUrl, { items: [{ id: toVariant || cfg.bundleVariantId, quantity: packs }] }).then(function (added) {
        return post(updateUrl, { updates: updates }).catch(function (err) {
          var line = added && added.items && added.items[0];
          if (!line) throw err;
          return post(changeUrl, { id: line.key, quantity: Math.max(0, line.quantity - packs) }).then(function () { throw err; });
        });
      });
    }
    function onCartPage() {
      var r = (window.routes && window.routes.cart_url) || '/cart';
      return window.location.pathname.replace(/\/$/, '') === r.replace(/\/$/, '');
    }
    function refreshDrawer() {
      var url = window.location.pathname + '?sections=cart-drawer,cart-icon-bubble';
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (sections) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: sections });
          drawer.classList.remove('is-empty');
        }
      });
    }

    function shipLine(a) {
      var el = document.createElement('p');
      el.className = 'cpk-cart cpk-cart__ship' + (a.free ? ' is-free' : '');
      var txt;
      if (a.bundleQty > 0 && cfg.alwaysFree) txt = T.freeBundle;
      else if (a.hasSub) txt = T.freeSub;
      else if (a.free) txt = T.free;
      else {
        var left = Math.max(100, freeMin - a.total);
        txt = tpl(T.left, { left: fmtShort(left), ship: fmtShort(cfg.shipCost || 0) });
      }
      el.innerHTML = truck + '<span></span>';
      el.lastChild.textContent = txt;
      return el;
    }
    // Kort med bilde, tekst og én knapp. action() returnerer et løfte med meldingen som vises etterpå.
    function card(extraClass, imgSrc, text, btnText, action) {
      var wrap = document.createElement('div');
      wrap.className = 'cpk-cart cpk-cart__upsell' + (extraClass ? ' ' + extraClass : '');
      var img = document.createElement('img');
      img.src = imgSrc || '';
      img.alt = '';
      img.loading = 'lazy';
      var p = document.createElement('p');
      p.className = 'cpk-cart__text';
      p.textContent = text;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cpk-cart__btn';
      b.textContent = btnText;
      b.addEventListener('click', function () {
        if (busy) return;
        busy = true; b.disabled = true;
        action().then(function (txt) {
          message = { text: txt, error: false };
        }).catch(function () {
          message = { text: T.error, error: true };
        }).then(function () {
          busy = false;
          return refreshDrawer();
        });
      });
      wrap.appendChild(img); wrap.appendChild(p); wrap.appendChild(b);
      return wrap;
    }
    // «Legg til den andre varen» – bare når nøyaktig én av varene mangler, uten rabatter på varene
    function upsellCard(a) {
      if (a.code || a.disc || a.pairs > 0) return null;
      var have = a.comps.filter(function (cs) { return cs.qty >= cs.c.qty; });
      var missing = a.comps.filter(function (cs) { return cs.qty < cs.c.qty; });
      if (have.length !== a.comps.length - 1 || missing.length !== 1) return null;
      var m = missing[0].c;
      var haveSum = have.reduce(function (s, cs) { return s + cs.c.price * cs.c.qty; }, 0);
      var add = cfg.bundlePrice - haveSum;
      var regular = m.price * m.qty;
      // Nov. 2026: foreslå bare pakken når den faktisk er billigere enn hver for seg
      if (add <= 0 || regular - add <= 0) return null;
      var text = tpl(T.upsell, {
        question: m.question || '',
        product: m.title,
        add: fmtShort(add),
        regular: fmtShort(regular),
        bundle: cfg.bundleTitle,
        save: fmtShort(regular - add)
      }).replace(/^\s+/, '');
      return card('', cfg.bundleImage || m.image, text, tpl(T.upsellBtn, { add: fmtShort(add) }), function () {
        var take = {};
        have.forEach(function (cs) { take[cs.c.variantId] = cs.c.qty; });
        // Pakken har alltid fri frakt
        return swap(a, 1, take).then(function () {
          return tpl(T.merged, { save: fmtShort(a.compSum - cfg.bundlePrice) });
        });
      });
    }
    // v6: pakken foreslås ikke lenger som abonnement i kurven (abonnementet er 3 pakker per levering)
    function subCard() { return null; }
    function decorate(a) {
      var inner = document.querySelector('#CartDrawer .drawer__inner');
      if (!inner) return;
      qsa(inner, '.cpk-cart').forEach(function (el) { el.remove(); });
      if (!a.cart.item_count) return;
      var header = qs(inner, '.drawer__header');
      var footer = qs(inner, '.drawer__footer');
      var upsell = upsellCard(a);
      var extra = upsell || subCard(a);
      var holder = document.createElement('div');
      holder.className = 'cpk-cart cpk-cart__top';
      if (message) {
        var msg = document.createElement('p');
        msg.className = 'cpk-cart cpk-cart__msg' + (message.error ? ' is-error' : '');
        msg.setAttribute('role', 'status');
        msg.textContent = message.text;
        holder.appendChild(msg);
        message = null;
      }
      holder.appendChild(shipLine(a));
      if (holder.childNodes.length) {
        if (header && header.nextSibling) header.parentNode.insertBefore(holder, header.nextSibling); else inner.insertBefore(holder, inner.firstChild);
      }
      if (extra && footer) footer.insertBefore(extra, footer.firstChild);
    }

    function run(allowMerge) {
      if (busy) { queued = true; if (allowMerge) queuedMerge = true; return; }
      // 3-pakk-byttet pågår: prøv igjen når det er ferdig
      if (window.__carnis3pkBusy) { setTimeout(function () { schedule(allowMerge); }, 300); return; }
      busy = true;
      getCart().then(function (cart) {
        var a = analyze(cart);
        // Nov. 2026 (3-pakk): nøyaktig 3 krukker hver for seg med både Storfetalg og Organmix → 3-pakken (billigere enn
        // Carnis-pakken + én krukke). Bare når 3-pakk-varianten finnes, er på lager og er billigere enn hver for seg.
        if (cfg.pk3 && cfg.pk3.length) {
          var plan = allowMerge ? optimize(a) : null;
          if (plan) {
            return applyPlan(plan).then(function () {
              message = { text: tpl(T.merged3 || T.merged, { save: fmtShort(plan.save), contents: plan.names }), error: false };
              busy = false;
              if (onCartPage()) { window.location.reload(); return; }
              return refreshDrawer();
            }).catch(function () {
              message = { text: T.error, error: true };
              busy = false;
              return refreshDrawer();
            });
          }
          decorate(a);
          busy = false;
          return;
        }
        // Nov. 2026: slå bare sammen til pakken når den faktisk er billigere enn hver for seg
        if (allowMerge && a.pairs > 0 && !a.code && !a.disc && a.compSum > cfg.bundlePrice) {
          var save = (a.compSum - cfg.bundlePrice) * a.pairs;
          return swap(a, a.pairs).then(function () {
            message = { text: tpl(T.merged, { save: fmtShort(save) }), error: false };
            busy = false;
            return refreshDrawer();
          }).catch(function () {
            message = { text: T.error, error: true };
            busy = false;
            return refreshDrawer();
          });
        }
        decorate(a);
        busy = false;
      }).catch(function () { busy = false; }).finally(function () {
        if (queued) { var qm = queuedMerge; queued = false; queuedMerge = false; schedule(qm); }
      });
    }
    // Samler raske endringer til én kjøring; et ønske om sammenslåing går ikke tapt i debouncen
    function schedule(allowMerge) {
      if (allowMerge) pendingMerge = true;
      clearTimeout(timer);
      timer = setTimeout(function () { var m = pendingMerge; pendingMerge = false; run(m); }, 150);
    }

    // Etter hver endring i kurven (legg i kurv, antall, fjern)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { schedule(true); });
    }
    // Når skuffen tegnes på nytt eller åpnes
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && 'MutationObserver' in window) {
      var wasActive = drawerEl.classList.contains('active');
      new MutationObserver(function (list) {
        var opened = false, redrawn = false;
        list.forEach(function (m) {
          if (m.type === 'attributes') {
            var active = drawerEl.classList.contains('active');
            if (active && !wasActive) opened = true;
            wasActive = active;
          } else if (m.type === 'childList') {
            var ours = Array.prototype.every.call(m.addedNodes, function (n) { return n.nodeType === 1 && n.classList && n.classList.contains('cpk-cart'); }) &&
              Array.prototype.every.call(m.removedNodes, function (n) { return n.nodeType === 1 && n.classList && n.classList.contains('cpk-cart'); });
            if (!ours) redrawn = true;
          }
        });
        if (opened) schedule(true);
        else if (redrawn) schedule(false);
      }).observe(drawerEl, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    }
    schedule(false);
  }

  function boot() {
    initCross();
    initCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
